angular.module('unica_campaign_template.campaign_template_services')

.factory('CampaignTemplateEditService', function ($http, getBaseApiURL) {

	var campaignTemplateEditService = {};

	campaignTemplateEditService.update = function (campaignTemplateData)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/campaign-template/update/' + campaignTemplateData.id,
			data: campaignTemplateData
		}).then(function(result) {

			if ( result ) {
				return result.data.campaign_template;
			}

		});
	};

	campaignTemplateEditService.deleteCover = function(id)
	{
		return $http({
			method: 'post',
			url: getBaseApiURL + '/campaign-template/remove-cover/' + id,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});
	};

	campaignTemplateEditService.deleteLogo = function(id)
	{
		return $http({
			method: 'post',
			url: getBaseApiURL + '/campaign-template/remove-logo/' + id,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});
	};

	campaignTemplateEditService.deleteImage = function(id)
	{
		return $http({
			method: 'post',
			url: getBaseApiURL + '/campaign-template/remove-image/' + id,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});
	};

	return campaignTemplateEditService;
});